import React from "react";
import Navbar from "./components/navbar/Navbar";
import Home from "./components/home/home";
function Landing() {
  return (
    <div className="landing-pg">
      <Navbar />
      <Home />
    </div>
  );
}

export default Landing;
